if(window.innerWidth < 1200) {

    // For all tables flexibles & tables comarquage
    // element that will be wrapped
    let tables = document.querySelectorAll('.table')
    
    tables.forEach(function(table) {

        // create wrapper container
        let wrapper = document.createElement('div');
        wrapper.classList.add("table--responsive");

        // insert wrapper before table in the DOM tree
        table.parentNode.insertBefore(wrapper, table);

        // move table into wrapper
        wrapper.appendChild(table);
    })


    // For all tables in bloc content (copy paste)
    let bloctables = document.querySelectorAll('.bloc-content table')
    
    bloctables.forEach(function(bloctable) {

        let wrapper = document.createElement('div');
        wrapper.classList.add("table--responsive");

        bloctable.parentNode.insertBefore(wrapper, bloctable);

        wrapper.appendChild(bloctable);
    })
}
